import { KTSVG } from '../../../../../_metronic/helpers'
import { getCategoryDisplayName } from '../../../../Utils/videoUtils';

interface SearchFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  selectedCategory: string;
  onCategoryChange: (value: string) => void;
  onClearFilters: () => void;
  categories?: string[];
}

export function SearchFilters({
  searchTerm,
  onSearchChange,
  selectedCategory,
  onCategoryChange,
  onClearFilters,
  categories = ["All"],
}: SearchFiltersProps) {
  const hasActiveFilters =
    searchTerm ||
    selectedCategory !== "All";

  return (
    <div className="bg-card rounded-lg p-6 shadow-sm border">
      <div className="flex gap-2 mb-4 align-items-center">
        <h2>
          {/* <KTSVG path="/media/icons/duotune/social/soc007.svg" className="w-5 h-5 mr-1" /> */}
          Filter Videos</h2>
      </div>

  <div className="d-flex align-items-center gap-3 mb-5" style={{ width: '66%', maxWidth: 700 }}>
          {/* Search Input */}
          <div className="position-relative flex-grow-1" style={{ minWidth: 200 }}>
            <KTSVG path="/media/icons/duotune/general/gen004.svg" className="position-absolute end-0 top-50 me-2 translate-middle-y" />
            <input
              type="text"
              placeholder="Search videos..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              className="form-control ps-5"
              style={{ height: 38, width: '100%' }}
            />
          </div>

          {/* Category Filter */}
          <div className="flex-grow-1" style={{ minWidth: 200 }}>
            <select
              value={selectedCategory}
              onChange={(e) => onCategoryChange(e.target.value)}
              className="form-select"
              style={{ height: 38, width: '100%' }}
            >
              {categories.map((category) => (
                <option key={category} value={category}>
                  {getCategoryDisplayName(category)}
                </option>
              ))}
            </select>
          </div>

          {/* Clear Filters */}
          {hasActiveFilters && (
            <button
              onClick={onClearFilters}
              className="btn btn-light border ms-2 d-flex align-items-center gap-2"
              style={{ height: 38 }}
            >
              <KTSVG path="/media/icons/duotune/general/gen034.svg" className="w-4 h-4" />
              Clear Filters
            </button>
          )}
        </div>

      </div>
  );
}